import { useState } from 'react';
import { Link, useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Plus } from 'lucide-react';
import { getApi } from '../api/endpoints';
import { useAsync } from '../hooks/useAsync';
import { ErrorBox, errorMessageKey } from './ErrorBox';
import { toastStore } from '../state/toasts';
import { meStore } from '../shell/me';

export function WorkspacesPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const list = useAsync('workspaces', () => getApi().listWorkspaces());
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);

  const create = async () => {
    if (name.trim() === '') return;
    setBusy(true);
    try {
      const ws = await getApi().createWorkspace(name.trim());
      setName('');
      void meStore.getState().load();
      void navigate(`/w/${ws.id}`);
    } catch (err) {
      toastStore.getState().push({ kind: 'error', message: t(errorMessageKey(err)) });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="page">
      <h1>{t('workspaces.title')}</h1>
      <form
        className="inline-form"
        onSubmit={(e) => {
          e.preventDefault();
          void create();
        }}
      >
        <label htmlFor="ws-name" className="sr-only">
          {t('workspaces.newName')}
        </label>
        <input
          id="ws-name"
          value={name}
          placeholder={t('workspaces.newName')}
          onChange={(e) => setName(e.target.value)}
          maxLength={100}
        />
        <button type="submit" className="btn btn-primary" disabled={busy || name.trim() === ''}>
          <Plus size={16} /> {t('workspaces.create')}
        </button>
      </form>
      {list.status === 'loading' && <p className="muted">{t('common.loading')}</p>}
      {list.status === 'error' && <ErrorBox error={list.error} onRetry={list.reload} />}
      {list.status === 'ready' && list.data.length === 0 && (
        <p className="muted">{t('workspaces.empty')}</p>
      )}
      {list.status === 'ready' && (
        <ul className="card-grid">
          {list.data.map((ws) => (
            <li key={ws.id} className="card">
              <Link to={`/w/${ws.id}`} className="card-title">
                {ws.name}
              </Link>
              <div className="muted small">
                {t(`role.${ws.role}`)} · {t('workspaces.boardsCount', { count: ws.usage.boards })}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
